import { render, staticRenderFns } from "./SmsTemplatesList.vue?vue&type=template&id=5f8ed4bf&scoped=true&"
import script from "./SmsTemplatesList.vue?vue&type=script&lang=ts&"
export * from "./SmsTemplatesList.vue?vue&type=script&lang=ts&"
import style0 from "./SmsTemplatesList.vue?vue&type=style&index=0&id=5f8ed4bf&lang=scss&scoped=true&"
import style1 from "./SmsTemplatesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ed4bf",
  null
  
)

export default component.exports